import { style } from "@vanilla-extract/css";
import { textTruncate } from "../../styles";
import { vars } from "../../styles/theme.css";

const baseStyles = style({
  flex: 1,
  border: "none",
  borderRadius: vars.space.xs,
  backgroundColor: "transparent",
  cursor: "pointer",
  padding: vars.space.xs,
  color: vars.colors.primary,
  fontFamily: "inherit",
  selectors: {
    "&[data-hovered]": {
      backgroundColor: `color-mix(in srgb, ${vars.colors.onPrimary}, ${vars.colors.primary} 2.5%)`,
    },
    "&[data-focused]": {
      backgroundColor: `color-mix(in srgb, ${vars.colors.onPrimary}, ${vars.colors.primary} 5%)`,
    },
    "&[data-selected]": {
      backgroundColor: vars.colors.surface,
    },
    "&[data-pressed]": {
      backgroundColor: `color-mix(in srgb, ${vars.colors.onPrimary}, ${vars.colors.primary} 10%)`,
    },
    "&[data-disabled]": {
      opacity: 0.5,
      border: vars.borders.disabled,
      backgroundColor: "transparent",
      cursor: "not-allowed",
      color: vars.colors.onDisabled,
    },
  },
});

export const toggleButton = style([baseStyles, textTruncate]);
